import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { autoSignIn, getCookie } from "./services/authentication"

import PrivacyPolicy from "./scenes/Public/PrivacyPolicy"
import ServiceProviders from "./scenes/Public/ServiceProviders"
import TermsOfService from "./scenes/Public/TermsOfService"
import App from "./scenes/App"
import Authentication from "./scenes/Authentication"
import ScrollToTop from "./components/ScrollToTop"

class Main extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true
    }

    if (getCookie("loggined")) {
      const token = JSON.parse(getCookie("loggined"))

      props.onAutoSignIn(token).then(
        () => {
          this.setState({
            loading: false
          })
        },
        () => {
          this.setState({
            loading: false
          })
        }
      )
    } else {
      this.state.loading = false
    }
  }

  render() {
    const { loading } = this.state

    return (
      <>
        {loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader loader--flex"
          />
        ) : (
          <>
            <ScrollToTop />
            <Switch>
              <Authentication
                exact
                path={[
                  "/sign-up",
                  "/sign-up/guardian/:token",
                  "/sign-in",
                  "/reset-password/:email/:code",
                  "/forgot-password",
                  "/verify-email/:code"
                ]}
              />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/service-providers" component={ServiceProviders} />
              <Route path="/terms-of-service" component={TermsOfService} />
              <Route path="/" component={App} />
            </Switch>
          </>
        )}
      </>
    )
  }
}

Main.propTypes = {
  onAutoSignIn: propTypes.func.isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  user: AuthenticationReducer.user
})

const mapDispatchToProps = dispatch => ({
  onAutoSignIn: token => dispatch(autoSignIn(token))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))
